import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface LinkableCardProps {
  linkTo?: string;
  children: React.ReactNode;
  containerClassName?: string;
}

export const LinkableCard = ({
  linkTo = '',
  children,
  containerClassName,
}: LinkableCardProps) => {
  return (
    <Link
      to={linkTo}
      className={twMerge(
        'flex flex-1 flex-col bg-white rounded-lg px-5 py-4 shadow',
        containerClassName
      )}
    >
      {children}
    </Link>
  );
};
